import kvalexandr from '../assets/team/kvalexandr.jpg';
import aleksei from '../assets/team/aleksei-bulgak-study.jpg';
import kvadeck from '../assets/team/kvadeck.jpg';
import spaceragga from '../assets/team/spaceragga.jpg';
import natein from '../assets/team/natein.jpg';


const team = [
  {
    name: 'Алексей Булгак',
    github: 'aleksei-bulgak-study',
    photo: aleksei,
    role: 'Разработчик',
    tasks: [
      'Страница регистрации и логина',
      'Страница "Статистика"',
      'Игра "Спринт"',
      'Создание API',
    ],
  },
  {
    name: 'Александр Кудрявцев',
    github: 'kvalexandr',
    photo: kvalexandr,
    role: 'Разработчик',
    tasks: [
      'Учебник и словарь',
      'Игра «Аудио вызов»',
      'Страница «Игры»',
      'Создание API',
    ],
  },
  {
    name: 'Николай Волженин',
    github: 'Kvadeck',
    photo: kvadeck,
    role: 'Разработчик',
    tasks: [
      'Игра «Саванна»',
      'Общие компоненты для игр',
      'Страница «404»',
    ],
  },
  {
    name: 'Иван Михальченко',
    github: 'spaceragga',
    photo: spaceragga,
    role: 'Разработчик',
    tasks: [
      'Дашборд, футер',
      'Главная страница, описание проекта',
      'Страница «Статистика»',
      'Страница «Отзывы о проекте»',
    ],
  },
  {
    name: 'Наталья Эйн',
    github: 'natein',
    photo: natein,
    role: 'Разработчик',
    tasks: [
      'Страница «О команде»',
      'Игра «Своя игра»',
    ],
  },
];

export default team;